import { useCallback, useEffect, useState } from "react";
import icTop from "assets/icons/ic-top.svg";

/**
 * 위로가기(스크롤 톱) 플로팅 버튼 — footer(하단 탭바)가 없는 페이지용.
 * 후니드 floating-btn.move-top 톤(주황 원형 + 흰 아이콘) 재현. 스크롤 200px↓ 노출.
 * 하단 탭바가 있는 페이지는 Footer 의 move-top 을 쓰므로 이 컴포넌트를 넣지 않는다.
 */
export default function ScrollTopFab() {
  const [show, setShow] = useState(false);
  // 하단 고정 액션바(.tab-bar-btn-group.fixed — 공고 상세 지원 바 등)가 있으면 그 위로 띄운다.
  //  바 높이는 글자 크기 설정(안드로이드 130% 등)에 따라 달라지므로 그때그때 잰다(px). 없으면 기본 위치.
  const [barOffset, setBarOffset] = useState(0);

  // window/내부 컨테이너 스크롤 모두 감지(capture) — Footer 와 동일 로직.
  useEffect(() => {
    const onScroll = (e) => {
      const y =
        (e && e.target && typeof e.target.scrollTop === "number" ? e.target.scrollTop : 0) ||
        window.scrollY ||
        document.documentElement.scrollTop ||
        0;
      setShow(y > 200);
      const bar = document.querySelector(".tab-bar-btn-group.fixed");
      const top = bar ? bar.getBoundingClientRect().top : null;
      setBarOffset(top != null && top < window.innerHeight ? Math.max(0, Math.round(window.innerHeight - top)) : 0);
    };
    window.addEventListener("scroll", onScroll, { passive: true, capture: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll, { capture: true });
  }, []);

  const toTop = useCallback(() => window.scrollTo({ top: 0, behavior: "smooth" }), []);

  if (!show) return null;

  return (
    <button
      type="button"
      onClick={toTop}
      aria-label="상단바로가기"
      style={{
        position: "fixed", right: "1.6rem", bottom: barOffset ? `calc(${barOffset}px + 1.2rem)` : "2.4rem", zIndex: 90,
        width: "4rem", height: "4rem", borderRadius: "99rem", border: "none",
        backgroundColor: "#F58232", boxShadow: "0 4px 12px 0 rgba(0,0,0,0.14)",
        display: "inline-flex", alignItems: "center", justifyContent: "center",
        cursor: "pointer", padding: 0,
      }}
    >
      <img
        src={icTop} alt="" aria-hidden="true"
        style={{
          width: "2rem", height: "2rem",
          filter: "brightness(0) saturate(100%) invert(100%)",
        }}
      />
    </button>
  );
}
